import DownloadIcon from '@mui/icons-material/Download'
import RefreshIcon from '@mui/icons-material/Refresh'
import { Box, Button, Stack } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useTranslation } from 'react-i18next'

interface LeadTimeFiltersProps {
  startDate: Date | null
  endDate: Date | null
  onStartDateChange: (date: Date | null) => void
  onEndDateChange: (date: Date | null) => void
  onRefresh: () => void
  onExport: () => void
  isLoading: boolean
}

const LeadTimeFilters = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onRefresh,
  onExport,
  isLoading,
}: LeadTimeFiltersProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="stretch">
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <DatePicker
            label={t('leadTime.filters.startDate')}
            value={startDate}
            onChange={onStartDateChange}
            disabled={isLoading}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <DatePicker
            label={t('leadTime.filters.endDate')}
            value={endDate}
            onChange={onEndDateChange}
            disabled={isLoading}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button variant="contained" onClick={onRefresh} disabled={isLoading} startIcon={<RefreshIcon />}>
            {t('leadTime.filters.refresh')}
          </Button>
          <Button variant="outlined" onClick={onExport} disabled={isLoading} startIcon={<DownloadIcon />}>
            {t('leadTime.filters.export')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
}

export default LeadTimeFilters
